<template>
	<div v-if="dataLoaded">
		<v-toolbar color="blue lighten-1" class="white--text">
			<v-icon color="white">person</v-icon>
			<v-toolbar-title>Eksperci</v-toolbar-title>
		</v-toolbar>
		<div class="ma-4">
			<v-layout row align-center>
				<v-flex xs1/>
				<v-flex xs3>
					<div style="display: flex; flex-direction: row; justify-content: space-between">
						<v-subheader>
							<strong>{{getExpertListLabel}}</strong>
						</v-subheader>
						<v-btn flat icon class="mr-5" @click="handleListExpansion">
							<v-icon>{{getExpertListIcon}}</v-icon>
						</v-btn>
					</div>
				</v-flex>
				<v-flex xs6>
					<i v-if="!showExpertsList">Lista ukryta</i>
				</v-flex>
			</v-layout>
			<v-layout row align-center>
				<v-flex xs1/>
				<v-flex xs9>
					<v-expand-transition v-if="showExpertsList">
						<v-list three-line>
							<template v-for="expert in experts">
								<v-list-tile :key="expert.id" avatar class="list-item">
									<v-list-tile-avatar>
										<v-icon>person</v-icon>
									</v-list-tile-avatar>
									<v-list-tile-content>
										<v-list-tile-title v-html="expert.name"
											style="font-size: 14px"/>
										<v-list-tile-sub-title
											v-html="expert.email"></v-list-tile-sub-title>
									</v-list-tile-content>
								</v-list-tile>
							</template>
						</v-list>
					</v-expand-transition>
				</v-flex>
			</v-layout>
		</div>
	</div>
</template>

<script>
	import {PublicContest} from "../../../../api/generated/PublicContest";

	export default {
		name: "ContestSummaryExpertsView",
		data() {
			return {
				experts: [],
				showExpertsList: false,
				dataLoaded: true
			};
		},
		created() {
			this.getExpertsList();
		},
		computed: {
			getExpertListLabel() {
				return this.showExpertsList ? 'Ukryj listę' : 'Wyświetl listę';
			},

			getExpertListIcon() {
				return this.showExpertsList ? 'keyboard_arrow_up' : 'keyboard_arrow_down';
			}
		},
		methods: {
			getExpertsList() {
				PublicContest.getExperts(this, this.$route.params.id, onSuccess => {
						this.experts = onSuccess;
					},
					onerror => {
						this.$messagesBus.$emit("error", "nie udało się wczytać listy ekspertów");
					});
			},
			handleListExpansion() {
				this.showExpertsList = !this.showExpertsList;
			},
		}
	};
</script>

<style scoped>

</style>
